<style lang="stylus">
    .worklist-filter{
        margin 0 auto
        max-width 100%
        width: calc(100% - 190px);
        position relative
    		@media screen and (max-width: 1920px) {
    			width: calc(100% - 278px);
    		}
        @media screen and (max-width: 1600px) {
    		  width: calc(100% - 168px);
    		}
        @media screen and (max-width: 1366px) {
    			width: calc(100% - 114px);
    		}
    		@media screen and (max-width: 1200px) {
    			width: calc(100% - 80px);
    		}

    		@media screen and (max-width: 768px) {
    			width: calc(100% - 218px);
    		}
        .selects{
            margin-bottom: 16px;
            .ivu-select-selected-value,
            .ivu-select-item {
              font-size: 14px !important;
            }
        }
    }
</style>
<template>
    <div class="worklist-filter">
        <div class="d-flex justify-content-end">
            <i-select @on-change="changeFilter" v-model="filterSource" class="selects" style="width: 120px; margin-right: 10px" v-if="lang == 'en'">
                <i-option v-for="item in sources" :value="item.value" :key="item.value">{{ item.label }}</i-option>
            </i-select>
            <i-select @on-change="changeFilter" v-model="filterSelect" class="selects" style="width: 150px">
                <i-option v-for="item in items" :value="item.value" :key="item.value">{{ item.label }}</i-option>
            </i-select>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filterSource: "1",
                filterSelect: "PV",
            };
        },
        computed: {
            items() {
                return [
                    {
                        label: "Recommended",
                        value: "PV",
                    },
                    {
                        label: "Popular",
                        value: "HOT",
                    },
                    {
                        label: this.$t("recent"),
                        value: "TIME",
                    },
                ];
            },
            sources() {
                return [
                    {
                        label: "All",
                        value: "1",
                    },
                    {
                        label: "Paid",
                        value: "2",
                    },
                    {
                        label: "Free",
                        value: "3",
                    },
                ];
            },
        },
        watch: {
            lang() {
                this.filterSource = "1";
            },
        },
        methods: {
            changeFilter() {
                this.$emit("on-filter", {
                    offset: 0,
                    order: this.filterSelect,
                    template_type: this.filterSource,
                });
            },
        },
    };
</script>
<i18n>
{
  "zh": {
    "trending": "趋势",
    "recent": "最近"
  },
  "en": {
    "trending": "Trending",
    "recent": "Recent"
  },
  "de": {
    "trending": "Tendenz",
    "recent": "Zuletzt"
  },
  "fr": {
    "trending": "Tendance",
    "recent": "Récent"
  },
  "es": {
    "trending": "Tendencias",
    "recent": "Recientes"
  },
  "jp": {
    "trending": "人気",
    "recent": "新着"
  },
  "it": {
    "trending": "Tendenza",
    "recent": "Recente"
  },
  "pt": {
    "trending": "Tendendo",
    "recent": "Recente"
  },
  "kr": {
    "trending": "인기 순",
    "recent": "신규 순"
  },
  "tw": {
    "trending": "趨勢",
    "recent": "最近"
  },
  "id": {
    "trending": "Sedang Tren",
    "recent": "Terbaru"
  }
}
</i18n>
